<template>
	 <div v-if="rowField.inputProps.disableEdit(rowData)"
    class="has-text-black-bis line-height is-size-3 edit-float">
      {{ datePlaceholder }}
  </div>
	<VDropdown v-else
		:shown="isOpen"
		:autoHide="false"
		placement="bottom-start"
		@update:shown="setDateOnShow">
		<div class="is-flex is-align-items-center is-clickable has-text-weight-normal
				is-justify-content-space-between has-background-white multidate-col"
			@click="isOpen = !isOpen">
			<div class="is-size-3 text-overflow text-clamp">
				{{ datePlaceholder }}
			</div>
				<i class="icon-datepicker"></i>
		</div>
		<!-- This will be the content of the popover -->
		<template #popper>
			<div  class="card">
				<section class="card-content m-0 has-background-white p-0">

					<div class="is-flex column p-0">
						<mf-date :rowData="rowData"
							:input-props="rowField.inputProps"
							:rowField="rowField"
              :is-edit="true"
							:showInline="true"
							dateClass="is-inline"
							:isModal="true"
							@setDate="storeSelectedDate">
						</mf-date>
						<!-- <o-datepicker
							v-model="toDate"
							class="is-inline"
							inline
							:max="rowField.inputProps.max"
						>
						</o-datepicker> -->
						<!-- :placeholder="dateFormat"
							:min-date="fromDate"
							:disabled="!fromDate"
							ref="fromDatePicker"
							:rootClass="fromDatePicker && fromDatePicker.showPrev ? 'prv-button' : ''" -->
					</div>
				</section>
				<footer
					class="card-footer is-justify-content-space-between has-background-white"
				>
					<div></div>
					<div class="buttons">
						<button
							@click="isOpen=false"
							class="button is-outlined has-background-white has-text-weight-bold"
						>
							Cancel
						</button>
						<button
							class="button has-text-weight-bold has-background-black-bis has-text-white"
							:disabled="applyDisabled"
							@click="applyDate"
						>
							Apply
						</button>
					</div>
				</footer>
			</div>
		</template>
	</VDropdown>
</template>

<script>
import moment from 'moment';
import { set } from 'lodash';
import { onBeforeMount, onBeforeUnmount, reactive, toRefs } from 'vue';
import MfDate from '@/components/abstract/MfDate.vue';

export default {
	name: 'CustomDatePicker',
	props: ['rowData', 'rowField'],
	components: {
		'mf-date': MfDate,
	},
	setup(props, { emit }) {
		const datePlaceHolder = 'mm/dd/yyyy';
		const data = reactive({
			isOpen: false,
			dateFormat: 'MM/DD/YYYY',
			datePlaceholder: datePlaceHolder,
			selectedDate: {},
		});

		const storeSelectedDate = (obj) => {
			data.selectedDate = obj;
		}
		
		const applyDate = () => {
			set(props.rowData, data.selectedDate.kind.value, moment(data.selectedDate.val).toISOString());
			emit('saveDate')
			data.isOpen = false;
		}
	
		onBeforeMount(() => {
			const date = _.get(props.rowData, props.rowField.prop, null);
			if (date) data.datePlaceholder = moment(date).format(data.dateFormat);
			else data.datePlaceholder = datePlaceHolder;
		})

		onBeforeUnmount(() => {
			const updatedDate = _.get(props.rowData, props.rowField.inputProps.kind);
			if (data.datePlaceholder !== updatedDate ) {
				_.set(props.rowData, props.rowField.inputProps.kind, data.datePlaceholder === 'mm/dd/yyyy' ? undefined : data.datePlaceholder);
			}
		})

		return {
			...toRefs(data),
			storeSelectedDate,
			applyDate
		}
	}
}
</script>

<style scoped>
	.card,
	::v-deep(.o-dpck) {
		width: auto !important;
		height: auto !important;
	}
	.card-content {
		height: 100% !important;
	}
	.card-footer {
		border-top: 1px solid #a6a6a6;
	}
	::v-deep(.o-drop__menu) {
		box-shadow: none !important;
	}
	.button.isOutlined {
		background: white !important;
	}
</style>